import React from 'react';
import ClientCarousel from '../UI/ClientCarousel';
import SectionWrapper from '../UI/SectionWrapper';
import muthoot from "../../../Assets/projects/muthoot.jpg";
import speehive from "../../../Assets/projects/speehive.jpg";
import al_ansari from "../../../Assets/projects/al_ansari.jpg";
import ashok_tradelines from "../../../Assets/projects/ashok-tradelines.jpg";
import purplecore from "../../../Assets/projects/purplecore.jpg";
import treat from "../../../Assets/projects/treat.jpg";


const slidesData = [
    {
      id: '1',
      heading: 'Enterprise Solutions',
      title: 'How Virtuosoft Enabled Muthoot EXIM Pvt. Ltd. to reduce the wait times for a walk-in customer by 6X ',
      body: 'This is an Enterprise-level ERP solution designed to streamline the Gold Purchasing process in both B2B retail and auction modes. The system allows Gold price determination process, Refinery process and Customer payouts. All related transactions are automatically updated in the accounting system to ensure accurate financial tracking.',
      image: muthoot,
      link: '/projects/muthoot',
    },
    {
      id: '2',
      heading: 'Technology Consulting',
      title: 'A Leading Shipping Company achieves 15X speed improvement in generating Maritime reports.',
      body: 'Provided architectural design and development support for a reporting framework with asynchronous and parallel processing capabilities, significantly improving report generation time. This enhancement led to improved client satisfaction and contributed to overall business growth.',
      image: speehive,
      link: '/projects/maritime',
    },
    {
        id: '3',
        heading: 'Inventory & Logistics Solution',
        title: 'Ashok Tradelines, a large distributor of construction materials achieves 30% improvement in their billing speed.',
        body: 'ERP system designed to bridge the gap between the procurement process where items are sourced from vendors and the invoicing system used to sell these items to both B2B and B2C customers. System enables accurate stock tracking, helping to prevent both understocking and overstocking.',
        image: ashok_tradelines,
        link: '/projects/ashok-tradelines',
      },
      {
        id: '4',
        heading: 'eCommerce Marketplace',
        title: 'Virtuosoft has Helped TREAT, Canada with a Reliable Mechanism and Strong Algorithm to search and find nearby stores and push deals to consumers',
        body: 'This is a Marketing Aggregator Platform that brings together offers from Restaurants, Grocery Stores, and Leisure Services, providing them as both Static and Dynamic Coupons. The platform features a robust store-location search algorithm that restricts store searches to the customer’s current location.',
        image: treat,
        link: '/projects/treat-inc',
      },
      {
        id: '5',
        heading: 'Technical Development & Enhancements ',
        title: 'Virtuosoft has Enabled Redha Al-Ansari Exchange, Dubai to manage counterfeit currency incidents in real-time',
        body: 'Centralized system that helps detect, report, and analyse counterfeit currency incidents in real-time. It integrates with physical currency detection machines regulatory databases to track counterfeit notes movement, patterns, and statistics. Also, it integrates with multiple payment vendor channels to enable seamless international payments with multi-currency support. ',
        image: al_ansari,
        link: 'projects/redha-al-ansari-exchange',
      },
      {
        id: '6',
        heading: 'Air/Marine Cargo Tracking Software',
        title: 'PurpleCore uses Virtuosoft for their Air/Marine Cargo Tracking Software. ',
        body: 'Technology Consultation/Development support for developing an aggregator application for tracking multiple airline and marine cargo services through a single interface. This solution eliminates the need to access separate portals for different carriers, streamlining operations and significantly improving tracking efficiency.',
        image: purplecore,
        link: 'projects/purplecore',
      },
    // Add more...
  ];

  function ProjectCarousal() {
    // return <ClientCarousel slides={slidesData} />;
    return (
      <SectionWrapper heading="PROJECTS">
        <ClientCarousel slides={slidesData} />
      </SectionWrapper>
    );
  }
  
  export default ProjectCarousal;
  